export const isCutOffPoint = (stackTrace: string): boolean => {
    return stackTraceCutOffPoint.some(cutOffPoint => stackTrace.includes(cutOffPoint))
}

const stackTraceCutOffPoint = [
    'Aws\\AwsClient::execute',
    'Doctrine\\DBAL\\Connection::executeQuery',
    'Doctrine\\DBAL\\Connection::executeStatement',
    'Doctrine\\DBAL\\Connection::executeUpdate',
    'Doctrine\\DBAL\\Connection::fetchAllAssociative',
    'Doctrine\\DBAL\\Connection::fetchOne',
    'Doctrine\\DBAL\\Query\\QueryBuilder::executeQuery',
    'Doctrine\\DBAL\\Statement::execute',
    'Doctrine\\DBAL\\Statement::executeQuery',
    'Doctrine\\DBAL\\Statement::executeStatement',
    'Doctrine\\ORM\\AbstractQuery::execute',
    'Doctrine\\ORM\\AbstractQuery::getResult',
    'Doctrine\\ORM\\AbstractQuery::getScalarResult',
    'Doctrine\\ORM\\EntityManager::find',
    'Doctrine\\ORM\\EntityManager::flush',
    'Doctrine\\ORM\\EntityRepository::findBy',
    'Doctrine\\ORM\\EntityRepository::findOneBy',
    'Elastic\\Elasticsearch\\Client::sendRequest',
    'Elastic\\Transport\\Transport::sendRequest',
    'Elasticsearch\\Client::performRequest',
    'Elasticsearch\\Transport::performRequest',
    'GuzzleHttp\\Client::request',
    'GuzzleHttp\\Client::requestAsync',
    'GuzzleHttp\\Client::send',
    'GuzzleHttp\\Client::sendAsync',
    'GuzzleHttp\\Client::sendRequest',
    'GuzzleHttp\\Client::transfer',
    'GuzzleHttp\\RedirectMiddleware::__invoke',
    'Illuminate\\Database\\Connection::run',
    'Illuminate\\Database\\Connection::runQueryCallback',
    'Illuminate\\Database\\Connection::statement',
    'Illuminate\\Database\\Query\\Builder::get',
    'Illuminate\\Database\\Query\\Builder::runSelect',
    'Magento\\Eav\\Model\\Entity\\Collection\\AbstractCollection::load',
    'Magento\\Framework\\Data\\Collection\\AbstractDb::getData',
    'Magento\\Framework\\DB\\Adapter\\Pdo\\Mysql::query',
    'OpenSearch\\Client::performRequest',
    'OpenSearch\\Transport::performRequest',
    'oxLegacyDb::execute',
    'oxLegacyDb::getAll',
    'oxLegacyDb::getOne',
    'oxLegacyDb::select',
    'Pheanstalk_Pheanstalk::_dispatch',
    'Pheanstalk_Pheanstalk::dispatch',
    'Pheanstalk_Pheanstalk::put',
    'Pheanstalk\\Pheanstalk::_dispatch',
    'Pheanstalk\\Pheanstalk::dispatch',
    'Pheanstalk\\Pheanstalk::put',
    'Shopware\\Core\\Framework\\DataAbstractionLayer\\Dbal\\EntityReader::read',
    'Shopware\\Core\\Framework\\DataAbstractionLayer\\Doctrine\\RetryableQuery::execute',
    'Shopware\\Core\\System\\SalesChannel\\Entity\\SalesChannelRepository::doSearch',
    'Stripe\\BaseStripeClient::request',
    'Symfony\\Component\\HttpClient\\Response\\CurlResponse::getContent',
    'Symfony\\Component\\HttpClient\\Response\\CurlResponse::getHeaders',
    'Symfony\\Component\\HttpClient\\Response\\CurlResponse::initialize',
    'WP_Http::request',
    'wpdb::get_results',
    'wpdb::query',
    'Zend_Db_Adapter_Abstract::fetchAll',
    'Zend_Db_Adapter_Abstract::fetchOne',
    'Zend_Db_Adapter_Abstract::query',
    'Zend_Db_Adapter_Pdo_Abstract::query',
]
